// extracted by mini-css-extract-plugin
export default {"container":"PeriodSelector_container__jHSwd","switch":"PeriodSelector_switch__qtpcY","tab":"PeriodSelector_tab__nJDMg","active":"PeriodSelector_active__ILsfM"};